# Типы коллекций текущей платформы (селект в форме коллекции)
query CollectionTypes {
  collectionTypes {
    id
    title
    showInSearch
    collectionDisplayMode
  }
}
